import React, { useState, useEffect } from 'react';

const SupportITButton = () => {
  const [isAutoExpanded, setIsAutoExpanded] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    let hideTimer;
    // Siklus expand/collapse otomatis setiap beberapa detik:
    // Terbuka selama 3.5 detik, lalu tertutup selama 5.5 detik (siklus 9 detik)
    const interval = setInterval(() => {
      setIsAutoExpanded(true);
      hideTimer = setTimeout(() => {
        setIsAutoExpanded(false);
      }, 3500);
    }, 9000);

    // Pertama kali muncul setelah 1.5 detik halaman dibuka agar terlihat informatif
    const initialTimer = setTimeout(() => {
      setIsAutoExpanded(true);
      hideTimer = setTimeout(() => {
        setIsAutoExpanded(false);
      }, 3500);
    }, 1500);

    return () => {
      clearInterval(interval);
      clearTimeout(hideTimer);
      clearTimeout(initialTimer);
    };
  }, []);

  const isExpanded = isAutoExpanded || isHovered;

  return (
    <a
      href="https://wa.me/6282177826596"
      target="_blank"
      rel="noreferrer"
      title="Hubungi Hubungi IT"
      style={{ textDecoration: 'none', display: 'inline-block' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div
        style={{
          height: 38,
          borderRadius: 20,
          backgroundColor: '#d1fae5',
          border: '1.5px solid #a7f3d0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: isExpanded
            ? '0 3px 10px rgba(16, 185, 129, 0.25)'
            : '0 2px 6px rgba(16, 185, 129, 0.12)',
          cursor: 'pointer',
          overflow: 'hidden',
          transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          transform: isHovered ? 'scale(1.04)' : 'scale(1)',
        }}
      >
        {/* Teks animasi "Hubungi IT" di sebelah kiri ikon */}
        <span
          style={{
            maxWidth: isExpanded ? 90 : 0,
            opacity: isExpanded ? 1 : 0,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            paddingLeft: isExpanded ? 12 : 0,
            paddingRight: isExpanded ? 2 : 0,
            fontSize: 12,
            fontWeight: 700,
            color: '#065f46',
            letterSpacing: '-0.2px',
            transition: 'max-width 0.45s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease, padding 0.45s cubic-bezier(0.4, 0, 0.2, 1)',
            display: 'inline-block',
            userSelect: 'none',
          }}
        >
          Hubungi IT
        </span>

        {/* Ikon Headset di sebelah kanan */}
        <div
          style={{
            width: 35,
            height: 35,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <i className="fas fa-headset" style={{ fontSize: 17, color: '#047857' }} />
        </div>
      </div>
    </a>
  );
};

export default SupportITButton;
